import { trackEvent } from "@/services/posthog.service";

export const EVENT_ASSIGNEE_CREATED = "MUTATION:ASSIGNEE:CREATED";
export const EVENT_ASSIGNEE_UPDATED = "MUTATION:ASSIGNEE:UPDATED";
export const EVENT_ASSIGNEE_DELETED = "MUTATION:ASSIGNEE:DELETED";

type AssigneeEventType = typeof EVENT_ASSIGNEE_CREATED | typeof EVENT_ASSIGNEE_UPDATED | typeof EVENT_ASSIGNEE_DELETED;

export const trackAssigneeEvent = (event: AssigneeEventType, payload: unknown) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trackEvent(event, payload as any);
};

export const EVENT_USER_FAVORITE_CREATED = "MUTATION:USER_FAVORITE:CREATED";
export const EVENT_USER_FAVORITE_DELETED = "MUTATION:USER_FAVORITE:DELETED";

type UserFavoriteEventType = typeof EVENT_USER_FAVORITE_CREATED | typeof EVENT_USER_FAVORITE_DELETED;

export const trackUserFavoriteEvent = (event: UserFavoriteEventType, payload: unknown) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trackEvent(event, payload as any);
};
